import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import User from 'src/store/models/User';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  props: ['onComplete', 'name'],
  components: {
    TeDialog: TeDialog
  },
  data: function data() {
    return {
      pagination: {
        rowsPerPage: 0
      },
      filter: '',
      columns: [{
        name: 'name',
        label: this.$tc('general.name', 1),
        align: 'left',
        sortable: false
      }],
      selected: []
    };
  },
  computed: {
    users: function users() {
      return User.query().where('enabled', 1).with('avatar').hasNot('groups').get();
    },
    title: function title() {
      return this.$t('components.groupAddUserDialog.add_member_to', {
        name: this.name
      });
    }
  },
  methods: {
    save: function save() {
      this.onOKClick(this.selected.map(function (user) {
        return {
          user_id: user.user_id,
          name: user.name,
          new: true
        };
      }));
    }
  }
};